export default "__VITE_ASSET__DZk6BC4W__"